import React, { Component } from 'react'
import FaPlay from 'react-icons/lib/fa/play'
import { browserHistory, Link } from 'react-router'
import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle'
import VideoProgress from '../../../misc/videoProgress/VideoProgress.js'
import VideoUrl from './VideoUrl'
import './videoItem.css'
import { createAction } from 'redux-actions'
import { cancel, ZOOM, deleteVideo, editVideo } from '../../../actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCode, faCut, faEllipsisH, faTrash } from '@fortawesome/free-solid-svg-icons'
import FaTrash from 'react-icons/lib/fa/trash'
import MdGraph from 'react-icons/lib/md/insert-chart'
import MdImage from 'react-icons/lib/md/image'
import MdUndo from 'react-icons/lib/md/undo'
import MdLock from 'react-icons/lib/md/lock'
import DownloadIcon from 'react-icons/lib/md/file-download'
import DropDown from '../../../misc/dropdown/DropDown'
import Checkbox from 'rc-checkbox'
import Textarea from 'react-textarea-autosize'
import '../../../misc/rc-checkbox.css'

function nFormatter(num, digits) {
  var si = [
    { value: 1E18, symbol: "E" },
    { value: 1E15, symbol: "P" },
    { value: 1E12, symbol: "T" },
    { value: 1E9,  symbol: "G" },
    { value: 1E6,  symbol: "M" },
    { value: 1E3,  symbol: "k" }
  ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;
  for (i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
    }
  }
  return num.toFixed(digits).replace(rx, "$1");
}

export default class GridItem extends Component {
  constructor() {
    super()

    this.state = {
      clipped: false,
    }
  }
  
  render() {
    const {
      props,
      toggleDeleteModal,
      toggleSelect,
      toggleEmbedModal,
      togglePrivacyModal,
      toggleFileListModal,
      children,
      onTitleChange,
    } = this.props

    const { video, dispatch } = props

    // override this here because we don't want it to adjust size on change, only on props change
    function textAreaChange(e) {
      this.props.onChange(e)
    }
    Textarea.prototype._onChange = textAreaChange

    let dropdownItems = [
      {
        onClick: (e) => {
          browserHistory.push(`/stats/${props.video.shortcode}`)
        },
        icon: <MdGraph />,
        title: 'Analytics',
      },
      {
        onClick: (e) => {
          browserHistory.push(`/thumbnail/${props.video.shortcode}`)
        },
        icon: <MdImage />,
        title: 'Edit Thumbnail',
      },
      {
        onClick: (e) => {
          togglePrivacyModal()
        },
        icon: <MdLock />,
        title: 'Privacy',
      },
      {
        onClick: (e) => {
          toggleFileListModal()
        },
        icon: <DownloadIcon />,
        title: 'Download Links'
      },
    ]
    dropdownItems.push({
      separator: true
    })
    dropdownItems.push({
        onClick: (e) => {
          toggleDeleteModal()
        },
        icon: <FaTrash />,
        title: 'Delete',
    })

    let thumbnailUrl = props.video.poster_url 
    if (props.video.thumbnail_url) {
      thumbnailUrl = props.video.thumbnail_url
    }

    return (
      <div
        className={
          `${props.reorderable ? 'reorderable' : ''} ${props.selected ? 'selected' : ''} col-lg-4 col-md-6 col-sm-12 col-12 grid video-item`
        }
      >
        {props.video.flagged == 1 || props.video.flagged == 2
          ?
          <div className="error-alert">
            <FaExclamationTriangle />
            <p>{props.video.flagged == 1 ? 'This video has been removed for violating our Terms of Service.' : 'This video is no longer available due to a copyright claim by the content owner.'}</p>
            <button
              onClick={(e) => {
                props.dispatch(deleteVideo(props.video))
              }}
            >
                Delete
              </button>
          </div>
          :
          props.video.status == 3
          ? 
          <div className="error-alert">
            <FaExclamationTriangle />
            <p dangerouslySetInnerHTML={{__html: props.video.error}}></p>
            <button
              onClick={(e) => {
                props.dispatch(cancel(props.video))
              }}
            >
                OK
              </button>
          </div>
          : <div>
            {children}
            <div className="card">
              <div
                className="video-thumbnail-container"
              >
                {(() => {
                  switch (props.video.status) {
                    case undefined:
                    case null:
                    case 0:
                    case 1:
                      return <VideoProgress video={props.video} />
                    case 2:
                      return (
                        <div
                          className="play-button"
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => {
                            if (e.ctrlKey || e.shiftKey) {
                              e.preventDefault()
                              return true
                            }

                            if (props.video.status === 2) {
                              props.dispatch(createAction(ZOOM)(props.video))
                            }

                            e.stopPropagation()
                            return false
                          }}
                        >
                          <FaPlay />
                        </div>
                      )
                    default:
                      return <div />
                  }
                })()}

                {thumbnailUrl
                  ? <img
                    className="card-img-top"
                    role="presentation"
                    src={thumbnailUrl}
                  />
                  : <div className="card-img-top" />}
                {props.video.status === 2 ?
                <div className="video-header">
                  <Checkbox
                    checked={props.selected}
                    onChange={toggleSelect}
                    className="video-item-checkbox"
                  />
                  <Link className="header-item float-right" to={`/stats/${props.video.shortcode}`} onClick={(e) => {
                    e.stopPropagation()
                  }}>
                    {nFormatter(props.video.plays, 0)} view{props.video.plays === 1 ? '' : 's'}
                  </Link>
                </div>
                : ''}
                {props.video.stale ?
                <div className="stale-notification">Pending Deletion</div>
                : ''}
              </div>
              <div className="card-block">
                <div className="card-metadata">
                  <Textarea
                    className="form-control edit-title-input"
                    maxLength="200"
                    placeholder="Add a title"
                    value={props.video.title}
                    onChange={(e) => { 
                      // check for line break
                      const match = /\r|\n/.exec(e.target.value);
                      if (match) {
                        onTitleChange(e.target.value.replace(/(\r\n|\n|\r)/gm,""), true)
                        e.target.blur()
                        return false
                      } 
                      onTitleChange(e.target.value)
                    }}
                  />
                  <VideoUrl {...props.video} />
                </div>
              </div>
              <div className="card-footer">
                
                {props.video.status === 2 ?
                  <DropDown
                    position="bottom left"
                    className="action-button rightmost"
                    items={dropdownItems}
                  >
                    <FontAwesomeIcon icon={faEllipsisH} /> More
                  </DropDown>
                : ''}
                
                {video.status == null || video.status < 2
                  ? '' : 
                  <button
                    className="action-button"
                    onClick={() => {
                      browserHistory.push(`/edit/${video.shortcode}`)
                    }}
                  >
                    <FontAwesomeIcon icon={faCut} /> Edit Video
                  </button>
                }

                {video.status == null || video.status < 2
                  ? <button
                    className="action-button rightmost"
                    onClick={() => {
                      dispatch(cancel(video))
                    }}
                  >
                    <FontAwesomeIcon icon={faTrash} />  Cancel
                  </button>
                : ''}
                {video.status == 2
                  ? 
                  <button
                    className="action-button"
                    onClick={() => {
                      toggleEmbedModal()
                    }}
                  >
                    <FontAwesomeIcon icon={faCode} /> Embed
                  </button>
                : ''}
                
                
              </div>
            </div>
          </div>}
      </div>
    )
  }
}
